module.exports = __webpack_public_path__ + "img/default-banner-image.340cd711.png";